import CameraPreview from '@/views/trainer/CameraPreview/CameraPreview.vue';
import ImagePreview from '@/views/trainer/ImagePreview/ImagePreview.vue';

export default {
	name: 'TrainderIndex',

	components: {
		CameraPreview,
		ImagePreview,
	},
	data() {
		return {};
	},

	props: {
		retrainModalId: {
			type: String,
		},
	},

	methods: {},
};
